var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRedHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37877 3.75C10.0024 3.75 11.3333 5.30279 11.8025 6.00467C11.8983 6.14408 12.0994 6.14408 12.1951 6.00467C12.6595 5.30759 13.9905 3.75 16.6189 3.75C20.2096 3.75 21.7512 7.27382 21.7512 9.43715C21.7512 12.9946 19.5154 15.0089 16.6189 17.7059L13.2292 20.5519C12.5159 21.148 11.4818 21.148 10.7732 20.5519L7.38356 17.7059C4.48704 15.0089 2.25122 12.9946 2.25122 9.43715C2.25122 7.27382 3.79284 3.75 7.38356 3.75H7.37877Z",
    fill: "#F0464F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.002 12.093C11.0847 12.093 10.3411 11.3494 10.3411 10.4322C10.3411 9.51503 11.0847 8.77148 12.002 8.77148C12.9193 8.77148 13.6628 9.51503 13.6628 10.4322C13.6628 11.3494 12.9193 12.093 12.002 12.093Z",
    fill: "#FFDA67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95416 15.6529C11.1144 15.6529 12.8903 15.6529 14.0505 15.6529C14.7421 15.6529 15.206 14.9352 14.9142 14.3077C14.4076 13.2211 13.2948 12.52 12.0029 12.52C10.711 12.52 9.59708 13.2223 9.0917 14.3077C8.79987 14.934 9.26372 15.6529 9.95534 15.6529H9.95416Z",
    fill: "#FFDA67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedHeart);
export default __webpack_public_path__ + "static/media/icon_red_heart.4d1f57d3.svg";
export { ForwardRef as ReactComponent };